import apiService from '../utils/apiService';

import {
  ADD_DECISION_TYPE,
  ADD_DECISION_TYPE_START,
  ADD_DECISION_TYPE_ERROR,
  UPDATE_DECISION_TYPE,
  UPDATE_DECISION_TYPE_START,
  UPDATE_DECISION_TYPE_ERROR,
  GET_DECISION_TYPE,
  GET_DECISION_TYPE_START,
  GET_DECISION_TYPE_ERROR,
  GET_DECISION_TYPE_LIST,
  GET_DECISION_TYPE_LIST_START,
  GET_DECISION_TYPE_LIST_ERROR,
  DELETE_DECISION_TYPE,
  DELETE_DECISION_TYPE_START,
  DELETE_DECISION_TYPE_ERROR,
  CLEAR_ERROR_DECISION_TYPE,
  GET_DECISION_TYPE_LIST_PAGEABLE,
  GET_DECISION_TYPE_ATTACHMENT,
  GET_DECISION_TYPE_ATTACHMENT_START,
  GET_DECISION_TYPE_ATTACHMENT_ERROR,
} from './types';

import {
  decisionTypeAddPath,
  decisionTypeUpdatePath,
  decisionTypeFindAllPath,
  decisionTypeFindByIdPath,
  decisionTypeDeletePath,
  decisionTypeFindAllPageablePath,
  decisionTypeWithAttachmentAddPath,
  decisionTypeAttachmentFindByDecisionTypePath,
} from '../constants/apiEndpoints';

import { createNotification } from '../utils';
import { notificationTypeError } from '../constants/globals';

const clearError = () => {
  return {
    type: CLEAR_ERROR_DECISION_TYPE,
  };
};

const addDecisionTypeStart = () => {
  return {
    type: ADD_DECISION_TYPE_START,
  };
};
const addDecisionTypeSuccessfully = (data) => {
  return {
    type: ADD_DECISION_TYPE,
    payload: data,
  };
};
const addDecisionTypeUnsuccessfully = (err) => {
  return {
    type: ADD_DECISION_TYPE_ERROR,
    payload: err,
  };
};

const updateDecisionTypeStart = () => {
  return {
    type: UPDATE_DECISION_TYPE_START,
  };
};
const updateDecisionTypeSuccessfully = (data) => {
  return {
    type: UPDATE_DECISION_TYPE,
    payload: data,
  };
};
const updateDecisionTypeUnsuccessfully = (err) => {
  return {
    type: UPDATE_DECISION_TYPE_ERROR,
    payload: err,
  };
};

const getDecisionTypeStart = () => {
  return {
    type: GET_DECISION_TYPE_START,
  };
};
const getDecisionTypeSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE,
    payload: data,
  };
};
const getDecisionTypeUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_ERROR,
    payload: err,
  };
};

const getDecisionTypeListStart = () => {
  return {
    type: GET_DECISION_TYPE_LIST_START,
  };
};
const getDecisionTypeListSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE_LIST,
    payload: data,
  };
};

const getDecisionTypePageableListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_DECISION_TYPE_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};
const getDecisionTypeListUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_LIST_ERROR,
    payload: err,
  };
};

const deleteDecisionTypeStart = () => {
  return {
    type: DELETE_DECISION_TYPE_START,
  };
};
const deleteDecisionTypeSuccessfully = (id) => {
  return {
    type: DELETE_DECISION_TYPE,
    payload: id,
  };
};
const deleteDecisionTypeUnsuccessfully = (err) => {
  return {
    type: DELETE_DECISION_TYPE_ERROR,
    payload: err,
  };
};

const getDecisionTypeAttachmentStart = () => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_START,
  };
};
const getDecisionTypeAttachmentSuccessfully = (data) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT,
    payload: data,
  };
};
const getDecisionTypeAttachmentUnsuccessfully = (err) => {
  return {
    type: GET_DECISION_TYPE_ATTACHMENT_ERROR,
    payload: err,
  };
};

export const createDecisionType = (decisionType, callback, messageTitle) => {
  return (dispatch) => {
    dispatch(addDecisionTypeStart());
    return apiService
      .post(decisionTypeAddPath(), decisionType)
      .then((response) => {
        dispatch(addDecisionTypeSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addDecisionTypeUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messageTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const updateDecisionType = (
  decisionType,
  callback,
  type,
  messageTitle
) => {
  return (dispatch) => {
    dispatch(updateDecisionTypeStart());
    return apiService
      .post(decisionTypeUpdatePath(type), decisionType)
      .then((response) => {
        dispatch(updateDecisionTypeSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(updateDecisionTypeUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messageTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const findAllDecisionTypes = () => {
  return (dispatch) => {
    dispatch(getDecisionTypeListStart());
    return apiService
      .get(decisionTypeFindAllPath())
      .then((response) => {
        dispatch(getDecisionTypeListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getDecisionTypeListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllDecisionTypesPageble = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getDecisionTypeListStart());
    return apiService
      .get(decisionTypeFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getDecisionTypePageableListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(getDecisionTypeListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findDecisionTypeById = (id) => {
  return (dispatch) => {
    dispatch(getDecisionTypeStart());
    return apiService
      .get(decisionTypeFindByIdPath(id))
      .then((response) => {
        dispatch(getDecisionTypeSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getDecisionTypeUnsuccessfully(err?.response?.data));
      });
  };
};

export const deleteDecisionType = (id, messageTitle) => {
  return (dispatch) => {
    dispatch(deleteDecisionTypeStart());
    return apiService
      .delete(decisionTypeDeletePath(id))
      .then(() => {
        dispatch(deleteDecisionTypeSuccessfully(id));
      })
      .catch((err) => {
        dispatch(deleteDecisionTypeUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messageTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const deleteErrorDecisionType = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const createDecisionTypeWithAttachment = (
  data,
  callback,
  type,
  messageTitle
) => {
  return (dispatch) => {
    dispatch(addDecisionTypeStart());
    return apiService
      .post(decisionTypeWithAttachmentAddPath(type), data)
      .then((response) => {
        dispatch(addDecisionTypeSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(addDecisionTypeUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messageTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const updateDecisionTypeWithAttachment = (
  data,
  callback,
  type,
  messageTitle
) => {
  return (dispatch) => {
    dispatch(updateDecisionTypeStart());
    return apiService
      .post(decisionTypeWithAttachmentAddPath(type), data)
      .then((response) => {
        dispatch(updateDecisionTypeSuccessfully(response.data));
        callback();
      })
      .catch((err) => {
        dispatch(updateDecisionTypeUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          messageTitle,
          err?.response?.data?.message
        );
      });
  };
};

// TODO - skinuti zavisnost od verzije ukoliko ih nece biti. Ali onda mora po max date? Pitati Vladu.
export const findDecisionTypeAttachment = (decisionTypeId) => {
  return (dispatch) => {
    dispatch(getDecisionTypeAttachmentStart());
    return apiService
      .get(decisionTypeAttachmentFindByDecisionTypePath(decisionTypeId))
      .then((response) => {
        dispatch(getDecisionTypeAttachmentSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getDecisionTypeAttachmentUnsuccessfully(err?.response?.data));
      });
  };
};
